import './interceptor'
import './fontawesome'
import 'bootstrap'


// WEBPACK FOOTER //
// ./src/plugins/index.js